// extracted by mini-css-extract-plugin
export default {"button":"_29m8cxe","message":"_36pFJIJ","title":"_1x-8flS","errorMessage":"_2r2JiJy"};